module.exports = __webpack_public_path__ + "img/cb2.e0c67c2c.jpg";